/**
 * Wrapper around generated RTK Query API with cleaner naming and custom logic.
 *
 * All endpoint references (keys, hooks, endpoint map) are derived from the
 * central definitions in `./config.ts` so generated names live in one place.
 */
import { generatedApi } from './api.generated';
import { createEndpointExports, createHookExports, LIST_TAG_ID } from '@skynet/data-helpers';
import type { HookExports } from '@skynet/data-helpers';
import { BOT_MESSAGES_API_ENDPOINTS as cfg } from './config';

/**
 * Both endpoints are read-only queries, so a single collection-level tag per
 * resource is sufficient — there are no mutations to invalidate them. Tags are
 * still declared so future write endpoints can invalidate the lists.
 */
export const botMessagesApi = generatedApi.enhanceEndpoints({
  addTagTypes: ['BotMessages', 'BotGroups'],
  endpoints: {
    [cfg.listBotGroups.generated]: {
      providesTags: [{ type: 'BotGroups', id: LIST_TAG_ID }],
    },
    [cfg.listBotMessages.generated]: {
      providesTags: [{ type: 'BotMessages', id: LIST_TAG_ID }],
    },
  },
});

// Re-export hooks with cleaner names via endpoint definitions
export const hookExports: HookExports<typeof cfg, typeof botMessagesApi> = createHookExports(
  cfg,
  botMessagesApi,
);

// Re-export endpoints object with cleaner names for direct usage
export const botMessagesApiEndpoints = createEndpointExports(cfg, botMessagesApi);
